import { OneDataCollection } from '@factorialco/f0-react/dist/experimental'

import { GetTaskTimeRecordsDocument } from 'generated/resources/graphql'

import { useGraphqlDataCollectionSource } from 'modules/core/hooks/useGraphqlDataCollectionSource'
import { buildUrl } from 'modules/core/lib/buildUrl'
import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import { formatProjectHours } from 'modules/project_management/lib/formatHours'

interface Props {
  projectTaskId: string
}

const TimeTracked = ({ projectTaskId }: Props) => {
  const source = useGraphqlDataCollectionSource({
    document: GetTaskTimeRecordsDocument,
    mapData: (data) => data.projectManagement.timeRecordsConnection.nodes,
    paginationType: 'pages',
    mapVariables: ({ search, pagination }) => ({
      projectTaskId,
      first: pagination?.perPage ?? 20,
      offsetPage: pagination?.currentPage ?? 1,
      employeeName: search ?? undefined,
    }),
    mapPagination: (data) => ({
      total: data.projectManagement.timeRecordsConnection.totalCount ?? 0,
    }),
    search: {
      enabled: true,
    },
  })

  return (
    <OneDataCollection
      source={source}
      visualizations={[
        {
          type: 'table',
          options: {
            columns: [
              {
                label: i18n.t('tasks.time_tracked_table.employee'),
                render: (item) => {
                  const employee = item.projectWorker?.employee
                  return {
                    type: 'person',
                    value: {
                      firstName: employee?.firstName ?? '',
                      lastName: employee?.lastName ?? '',
                      src: employee?.access?.avatar ? buildUrl(employee.access.avatar) : undefined,
                    },
                  }
                },
              },
              {
                label: i18n.t('tasks.time_tracked_table.hours'),
                render: (item) => ({
                  type: 'text',
                  value: formatProjectHours(item.imputedMinutes ?? null),
                }),
              },
              {
                label: i18n.t('tasks.time_tracked_table.date'),
                render: (item) => ({
                  type: 'text',
                  value: item.date
                    ? i18nDateToString(stringToDate(item.date, 'backend'), 'ui')
                    : '-',
                }),
              },
            ],
          },
        },
      ]}
    />
  )
}

export default TimeTracked
